import Enterprise from 'views/Users/Details/UserDetails/subcomponents/Enterprise';
import Corporate from 'views/Users/Details/UserDetails/subcomponents/Corporate';
import React, { useMemo } from 'react';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { SingleCorpAccount } from 'utils/api/models/accounts/singleCorpAccount';
import { SingleDepartment } from 'utils/api/models/departments/singleDepartment';

interface IUserInformationProps {
	user: types.users.IExtendedCorpUserDetails;
	accounts: SingleCorpAccount[];
	departments: SingleDepartment[];
	canPerformAction: string;
	setDialog: React.Dispatch<React.SetStateAction<types.users.editDialog>>;
	resendEmailOnClick: () => void;
	handleEditPermission: (accountId: string) => void;
	accountsWithoutPermissions: SingleCorpAccount[];
	handleDeletePermission: (accountId: string, userId: string) => void;
}

const UserInformation = ({
	user,
	accounts,
	departments,
	canPerformAction,
	setDialog,
	resendEmailOnClick,
	handleEditPermission,
	accountsWithoutPermissions,
	handleDeletePermission,
}: IUserInformationProps) => {
	const isEndUser: boolean = !!user && user.userData.userType === 'ENDUSER';
	const isManager: boolean = !!user && user.userData.userType === 'MANAGER';
	const isAdmin: boolean = !!user && user.userData.userType === 'ADMIN';
	const isEnterprise: boolean = useMemo(() => accounts.length > 1, [accounts]);

	const resendEmailEnabled: boolean =
		(user?.userData?.userType === 'MANAGER' || user?.userData?.userType === 'ADMIN') && !user?.userData?.lastLogin;

	const handleEditUserType = (): void => setDialog('editUserType');
	const handleClickEditUserAccount = (): void => setDialog('editUserAccount');
	const handleClickAddDepartmentPermission = (): void => setDialog('addPermission');
	const handleClickAddBillingAccountPermission = (): void => setDialog('addBillingAccountPermission');

	return (
		<ConditionalRender
			show={isEnterprise}
			onTrue={() => (
				<Enterprise
					user={user}
					handleEditUserType={handleEditUserType}
					isManager={isManager}
					isAdmin={isAdmin}
					isEndUser={isEndUser}
					accounts={accounts}
					departments={departments}
					handleClickEditUserAccount={handleClickEditUserAccount}
					handleClickEditPermission={handleEditPermission}
					handleClickAddPermission={handleClickAddDepartmentPermission}
					handleClickAddBillingAccountPermission={handleClickAddBillingAccountPermission}
					accountsWithoutPermissions={accountsWithoutPermissions}
					canPerformAction={canPerformAction}
					resendEmail={{
						enabled: resendEmailEnabled,
						onClick: resendEmailOnClick,
					}}
					handleDeletePermission={handleDeletePermission}
				/>
			)}
			onFalse={() => (
				<Corporate
					isAdmin={isAdmin}
					isManager={isManager}
					isEndUser={isEndUser}
					handleEditUserType={handleEditUserType}
					handleClickEditPermission={handleEditPermission}
					handleClickAddPermission={handleClickAddDepartmentPermission}
					handleClickAddBillingAccountPermission={handleClickAddBillingAccountPermission}
					user={user}
					canPerformAction={canPerformAction}
					resendEmail={{
						enabled: resendEmailEnabled,
						onClick: resendEmailOnClick,
					}}
				/>
			)}
		/>
	);
};

export default UserInformation;
